<template>
  <div class="data-query-container">
    <!-- 数据汇总卡片 -->
    <div class="summary-cards">
      <div class="summary-card" v-for="(item, key) in summaryData" :key="key">
        <div class="card-icon">
          <i :class="getCardIcon(key)"></i>
        </div>
        <div class="card-content">
          <h3>{{ getCardTitle(key) }}</h3>
          <div class="card-stats">
            <div class="stat-item">
              <span class="stat-label">总数量:</span>
              <span class="stat-value">{{ item.total_count }}</span>
            </div>
            <div class="stat-item" v-if="item.avg_score > 0">
              <span class="stat-label">平均分:</span>
              <span class="stat-value">{{ item.avg_score.toFixed(2) }}</span>
            </div>
            <div class="stat-item" v-if="item.latest_date">
              <span class="stat-label">最新日期:</span>
              <span class="stat-value">{{ item.latest_date }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 数据类型选择 -->
    <div class="data-type-tabs">
      <div 
        class="tab-item" 
        :class="{ active: activeTab === tab.key }"
        v-for="tab in dataTabs" 
        :key="tab.key"
        @click="switchTab(tab.key)"
      >
        <i :class="tab.icon"></i>
        {{ tab.label }}
      </div>
    </div>

    <!-- 数据内容区域 -->
    <div class="data-content">
      <!-- CFC数据 -->
      <div v-if="activeTab === 'cfc'" class="data-section">
        <CfcDataView />
      </div>

      <!-- 周测数据 -->
      <div v-if="activeTab === 'weekly_test'" class="data-section">
        <WeeklyTestDataView />
      </div>

      <!-- 心理测评数据 -->
      <div v-if="activeTab === 'psychological_test'" class="data-section">
        <PsychologicalTestDataView />
      </div>

      <!-- 体测数据 -->
      <div v-if="activeTab === 'physical_test'" class="data-section">
        <PhysicalTestDataView />
      </div>
    </div>
  </div>
</template>

<script>
import CfcDataView from './data-query/CfcDataView.vue'
import WeeklyTestDataView from './data-query/WeeklyTestDataView.vue'
import PsychologicalTestDataView from './data-query/PsychologicalTestDataView.vue'
import PhysicalTestDataView from './data-query/PhysicalTestDataView.vue'
import { getDataSummary } from '../../api/dataQueryApi'

export default {
  name: 'DataQuery',
  components: {
    CfcDataView,
    WeeklyTestDataView,
    PsychologicalTestDataView,
    PhysicalTestDataView
  },
  data() {
    return {
      activeTab: 'cfc',
      summaryData: {},
      loading: false,
      dataTabs: [
        { key: 'cfc', label: 'CFC数据', icon: 'el-icon-document' },
        { key: 'weekly_test', label: '周测数据', icon: 'el-icon-edit-outline' },
        { key: 'psychological_test', label: '心理测评', icon: 'el-icon-user' },
        { key: 'physical_test', label: '体测数据', icon: 'el-icon-trophy' }
      ]
    }
  },
  mounted() {
    this.loadSummaryData()
  },
  methods: {
    async loadSummaryData() {
      try {
        this.loading = true
        const response = await getDataSummary()
        this.summaryData = response.data
      } catch (error) {
        console.error('获取数据汇总失败:', error)
        this.$message.error(error.message || '获取数据汇总失败')
      } finally {
        this.loading = false
      }
    },
    switchTab(tabKey) {
      this.activeTab = tabKey
    },
    getCardTitle(key) {
      const titles = {
        cfc: 'CFC数据',
        weekly_test: '周测数据',
        psychological_test: '心理测评',
        physical_test: '体测数据'
      }
      return titles[key] || '未知数据'
    },
    getCardIcon(key) {
      const icons = {
        cfc: 'el-icon-document',
        weekly_test: 'el-icon-edit-outline',
        psychological_test: 'el-icon-user',
        physical_test: 'el-icon-trophy'
      }
      return icons[key] || 'el-icon-info'
    }
  }
}
</script>

<style scoped>
.data-query-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.page-header {
  margin-bottom: 30px;
  text-align: center;
}

.page-header h2 {
  color: #333;
  margin-bottom: 10px;
  font-size: 28px;
  font-weight: 600;
}

.page-header p {
  color: #666;
  font-size: 16px;
}

.summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.summary-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
}

.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.card-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}

.card-icon i {
  font-size: 24px;
  color: white;
}

.card-content h3 {
  color: #333;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
}

.card-stats {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.stat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.stat-label {
  color: #666;
  font-size: 14px;
}

.stat-value {
  color: #333;
  font-weight: 600;
  font-size: 14px;
}

.data-type-tabs {
  display: flex;
  background: white;
  border-radius: 12px;
  padding: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.tab-item {
  flex: 1;
  padding: 12px 20px;
  text-align: center;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s ease;
  color: #666;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.tab-item:hover {
  background-color: #f8f9fa;
  color: #333;
}

.tab-item.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.tab-item i {
  font-size: 16px;
}

.data-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.data-section {
  padding: 20px;
}

@media (max-width: 768px) {
  .data-query-container {
    padding: 15px;
  }
  
  .summary-cards {
    grid-template-columns: 1fr;
  }
  
  .data-type-tabs {
    flex-direction: column;
    gap: 8px;
  }
  
  .tab-item {
    padding: 10px 15px;
  }
}
</style>
